import {isPlatformBrowser} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {DOCUMENT, inject, Injectable, PLATFORM_ID} from '@angular/core';
import {
  ELanguages,
  TranslateHelper,
} from '@binotel-frontend/bnt-common-components';
import {PEREVIR_APP_TITLE_POSTFIX} from '@entities/common/constants';
import {environment} from '@envs/environment';
import {Store} from '@ngrx/store';
import {SnackbarHelper} from '@shared/helper/snackbar.helper';
import {TitleHelper} from '@shared/helper/title.helper';
import {SnackbarService} from '@shared/services/snackbar.service';
import {CommonActions} from '@state/common/common.actions';
import {Observable, tap} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly document = inject(DOCUMENT);
  private readonly httpClient = inject(HttpClient);
  private readonly snackbar = inject(SnackbarService);
  private readonly store = inject(Store);

  public initializeApp(): Observable<boolean> {
    if (this.isBrowser) {
      console.warn(
        `Binotel ${environment.projectName} Version ${environment.releaseVersion} (${environment.releaseDate})`
      );
      SnackbarHelper.init(this.snackbar);
    }
    TitleHelper.init(PEREVIR_APP_TITLE_POSTFIX);
    TranslateHelper.initService(this.httpClient, environment.releaseVersion);

    const lang = TranslateHelper.getSupportedLanguage([
      ELanguages.UA,
      ELanguages.EN,
    ]);

    return TranslateHelper.prepareLanguage(lang).pipe(
      tap(() =>
        this.document.documentElement.setAttribute(
          'lang',
          TranslateHelper.getLocaleByLanguage(lang)
        )
      ),

      tap(() => this.store.dispatch(CommonActions.appInit()))
    );
  }
}
